import { useQuery } from "@tanstack/react-query"
import { getEntidadCuentaContableCuenta } from "./CuentaContable_Cuenta.service"
import {
  CATEGORIA_CUENTA_CONTABLE_ENUM,
  CategoriaCuentaContableEnumType,
} from "./Types/CategoriaCuentaContableEnum"

const generarHookParaEntidad = (entidad?: CategoriaCuentaContableEnumType) => {
  return () => {
    const {
      data: cuentasContablesEmpresas,
      isLoading: cuentasContablesEmpresasIsLoading,
      error: cuentasContablesEmpresasError,
      refetch: cuentasContablesEmpresasRefetch,
    } = useQuery({
      queryKey: [`cuentasContablesCuentas/${entidad}`],
      queryFn: () => getEntidadCuentaContableCuenta(entidad),
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 20,
      retry: false,
    })

    return {
      cuentasContablesEmpresas,
      cuentasContablesEmpresasIsLoading,
      cuentasContablesEmpresasError,
      cuentasContablesEmpresasRefetch,
    }
  }
}

const useCuentaContableCuentaAll = generarHookParaEntidad()
const useCuentaContableCuentaOtro = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.OTRO
)
const useCuentaContableCuentaCliente = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.CLIENTE
)
const useCuentaContableCuentaProveedor = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PROVEEDOR
)
const useCuentaContableCuentaCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.COMPRA
)
const useCuentaContableCuentaVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
)
const useCuentaContableCuentaPrestamoConcedido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_CONCEDIDO
)
const useCuentaContableCuentaPrestamoRecibido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_RECIBIDO
)
const useCuentaContableCuentaInteresPrestamoConcedido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_CONCEDIDO
)
const useCuentaContableCuentaInteresPrestamoRecibido = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_RECIBIDO
)
const useCuentaContableCuentaIvaCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_COMPRA
)
const useCuentaContableCuentaIvaVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_VENTA
)
const useCuentaContableCuentaRetencionCompra = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_COMPRA
)
const useCuentaContableCuentaRetencionVenta = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_VENTA
)
const useCuentaContableCuentaCuentaBancaria = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.CUENTA_BANCARIA
)
const useCuentaContableCuentaComisionAperturaPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_CONCEDIDO
  )
const useCuentaContableCuentaComisionAperturaPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_RECIBIDO
  )
const useCuentaContableCuentaComisionCorretajePrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_CONCEDIDO
  )
const useCuentaContableCuentaComisionCorretajePrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_RECIBIDO
  )
const useCuentaContableCuentaComisionDisposicionPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_CONCEDIDO
  )
const useCuentaContableCuentaComisionDisposicionPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_RECIBIDO
  )
const useCuentaContableCuentaComisionEstudioPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_CONCEDIDO
  )
const useCuentaContableCuentaComisionEstudioPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_RECIBIDO
  )
const useCuentaContableCuentaComisionOtraPrestamoRecibido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_RECIBIDO
  )
const useCuentaContableCuentaComisionOtraPrestamoConcedido =
  generarHookParaEntidad(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_CONCEDIDO
  )

const useCuentaContableCuentaTicketReembolso = generarHookParaEntidad(
  CATEGORIA_CUENTA_CONTABLE_ENUM.TICKET_REEMBOLSO
)
export {
  useCuentaContableCuentaAll,
  useCuentaContableCuentaCliente,
  useCuentaContableCuentaComisionAperturaPrestamoConcedido,
  useCuentaContableCuentaComisionAperturaPrestamoRecibido,
  useCuentaContableCuentaComisionCorretajePrestamoConcedido,
  useCuentaContableCuentaComisionCorretajePrestamoRecibido,
  useCuentaContableCuentaComisionDisposicionPrestamoConcedido,
  useCuentaContableCuentaComisionDisposicionPrestamoRecibido,
  useCuentaContableCuentaComisionEstudioPrestamoConcedido,
  useCuentaContableCuentaComisionEstudioPrestamoRecibido,
  useCuentaContableCuentaComisionOtraPrestamoConcedido,
  useCuentaContableCuentaComisionOtraPrestamoRecibido,
  useCuentaContableCuentaCompra,
  useCuentaContableCuentaCuentaBancaria,
  useCuentaContableCuentaInteresPrestamoConcedido,
  useCuentaContableCuentaInteresPrestamoRecibido,
  useCuentaContableCuentaIvaCompra,
  useCuentaContableCuentaIvaVenta,
  useCuentaContableCuentaOtro,
  useCuentaContableCuentaPrestamoConcedido,
  useCuentaContableCuentaPrestamoRecibido,
  useCuentaContableCuentaProveedor,
  useCuentaContableCuentaRetencionCompra,
  useCuentaContableCuentaRetencionVenta,
  useCuentaContableCuentaTicketReembolso,
  useCuentaContableCuentaVenta,
}
